export function formatNumber(
  value: number | null | undefined,
  locales: string | string[] = 'en-US', // Default to US English formatting
  minimumFractionDigits: number = 2,
  maximumFractionDigits: number = 2,
): string {
  if (value === null || value === undefined || isNaN(value)) {
    // Handle cases where the value is not a valid number
    // You might want to return 'N/A', '0.00', an empty string, or throw an error
    return '0.00'; // Or 'N/A', '', etc.
  }

  const options: Intl.NumberFormatOptions = {
    style: 'decimal', // Can also be 'currency', 'percent', etc.
    useGrouping: true, // This enables the comma as a thousands separator
    minimumFractionDigits: minimumFractionDigits,
    maximumFractionDigits: maximumFractionDigits,
  };

  try {
    return new Intl.NumberFormat(locales, options).format(value);
  } catch (error) {
    console.error('Error formatting number:', error);
    // Fallback to a simple toFixed if Intl fails (e.g., invalid locale)
    return value.toFixed(minimumFractionDigits);
  }
}
